import { AnyAction } from 'redux'

export const ENTRY_POINT = 'ENTRY_POINT'
export const setEntryPoint = (point: string) => ({
  type: ENTRY_POINT,
  point,
})
export const entryPointReducer = (
  current: string = '',
  action: AnyAction,
): string => {
  switch (action.type) {
    case ENTRY_POINT:
      return action.point
    default:
      return current
  }
}
